import React from 'react';
import PropTypes from 'prop-types';
import { getTenantConfig } from 'utils/tenant';
import { SFEntityID } from 'utils/types';

export default class StudentListSuccessScore extends React.Component {

  get cardData() {
    if (!getTenantConfig('ENABLE_SUCCESS_SCORE_HISTORY_CHART')) return {};
    return {
      'data:card-type': 'success-score',
      'data:card-id': this.props.studentId
    }
  }

  get successScoreClasses() {
    return 'sf-success-score horizontal '
      + this.props.getSuccessScoreRange(this.props.successScore)
      + (!getTenantConfig('ENABLE_SUCCESS_SCORE_HISTORY_CHART') ? '' : ' sf-card-trigger unbound');
  }

  get inversePosition() {
    return 100 - this.props.successScore;
  }

  render() {
    if (this.props.successScore < 0) return null;
    return (
      <div {...this.cardData} className={this.successScoreClasses}>
        <div className="value">{this.props.successScore}</div>
        <div className="bar" aria-hidden="true">
          <div className={`mask mask${this.inversePosition}`} style={{width: this.inversePosition + '%'}}>&nbsp;</div>
        </div>
      </div>
    );
  }

}

StudentListSuccessScore.propTypes = {
  studentId: SFEntityID.isRequired,
  successScore: PropTypes.number.isRequired,
  getSuccessScoreRange: PropTypes.func.isRequired
}
